// extracted by mini-css-extract-plugin
export default {"separator":"Separator_separator__mzE3C"};